// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import styles from './SlideShow.module.scss';

export default class SlideShow extends Component {
  containerRef = React.createRef();

  wrapperWidth = 0;

  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
    };
  }

  componentDidMount() {
    this.updateDimensions();

    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    const wrapperEl = this.containerRef.current;
    const sliderEl = wrapperEl.firstChild;
    const { media } = this.props;
    const { width } = wrapperEl.parentElement.getBoundingClientRect();
    this.wrapperWidth = width;
    this.sliderWidth = media.length * width;
    sliderEl.style.width = `${this.sliderWidth}px`;

    if (sliderEl.hasChildNodes()) {
      const slides = sliderEl.childNodes;
      for (let i = 0; i < slides.length; i += 1) {
        const element = slides[i];
        element.style.width = `${this.wrapperWidth}px`;
      }
    }
  };

  handleNextClick = () => {
    const { media } = this.props;
    const { currentSlide } = this.state;
    if (currentSlide < media.length - 1) {
      this.setState({
        currentSlide: currentSlide + 1,
      });
    }
  };

  handlePreviousClick = () => {
    const { currentSlide } = this.state;
    if (currentSlide > 0) {
      this.setState({
        currentSlide: currentSlide - 1,
      });
    }
  };

  renderMedia() {
    const { currentSlide } = this.state;
    const { media, altText } = this.props;
    return media.map((slide, i) => {
      if (slide.video) {
        return (
          <div className={styles.slide}>
            <ReactPlayer
              className={styles['video-player']}
              url={slide.video}
              playing={currentSlide === i}
              loop
              controls
              playsinline
            />
          </div>
        );
      }

      return (
        <div className={styles.slide}>
          <div className={styles.slideBG} style={{ backgroundImage: `url(${slide.large})` }} />
          <img src={slide.large} alt={altText} />
        </div>
      );
    });
  }

  render() {
    const { media } = this.props;
    const { currentSlide } = this.state;
    const x = -(this.wrapperWidth * currentSlide);

    return (
      <div ref={this.containerRef} className={styles.slideshow}>
        <div className={styles.slider} style={{ transform: `translateX(${x}px)` }}>
          {this.renderMedia()}
        </div>
        {currentSlide + 1 < media.length && (
          <div
            className={[styles.button, styles.nextBtn].join(' ')}
            onClick={this.handleNextClick}
          />
        )}
        {currentSlide > 0 && (
          <div
            className={[styles.button, styles.previousBtn].join(' ')}
            onClick={this.handlePreviousClick}
          />
        )}
      </div>
    );
  }
}
